// extracted by mini-css-extract-plugin
export default {"banner":"banner--345721b","title":"title--5a4d3a9"};